import { API } from '.'
import { handleResponse, handleLoginResponse } from '../helpers';
import { API_URL } from '../config/appConfig';
import { accountLinkingConstants } from '../constants';

const systemUserLogin = async (username, password) => {
    return API.post(`${API_URL.idpAuth}/system/auth/login`, "login", { username, password })
        .then(handleLoginResponse)
}

const systemUserLogout = () => {
    return API.post(`${API_URL.idp}/system/auth/logout`, "logout", {})
        .then(handleResponse)
        .then(() => ({}))
}

const tenantUserLogin = async (username, password, clientId) => {
    return API.post(`${API_URL.idpAuth}/auth/login`, "login", {
        username,
        password,
        clientId,
    }).then(handleLoginResponse)
}

const tenantUserLogout = () => {
    return API.post(`${API_URL.idp}/auth/logout`, "logout", {})
        .then(handleResponse)
        .then(() => ({}))
}

const compactOAuthLoginBody = (reqBody) =>
    Object.fromEntries(
        Object.entries(reqBody).filter(
            ([, value]) => value !== null && value !== undefined && String(value).trim() !== ""
        )
    );

const getAccountLinkingAuthToken = (username, password, clientId, responseType, redirectURL) => {
    const reqBody = compactOAuthLoginBody({
        password,
        clientId,
        responseType,
        redirectUrl: redirectURL,
        ...(username.includes("@") ? { email: username } : { mobile: username }),
    });

    return API.post(`${API_URL.idpAuth}/oauth2/login`, accountLinkingConstants.API_KEY, reqBody)
        .then((res) => handleResponse(res, true))
}

/** OAuth login after OTP verification (token from validateOtp). */
const getAccountLinkingAuthTokenViaOtp = (username, otpToken, clientId, responseType, redirectURL) => {
    const reqBody = compactOAuthLoginBody({
        token: otpToken,
        clientId,
        responseType,
        redirectUrl: redirectURL,
        ...(username.includes("@") ? { email: username } : { mobile: username }),
    });

    return API.post(`${API_URL.idpAuth}/oauth2/login`, accountLinkingConstants.API_KEY, reqBody)
        .then((res) => handleResponse(res, true))
}

const getAccountLinkingAuthCode = (scope, accepted, authorizationToken) => {
    return API.post(`${API_URL.idpAuth}/oauth2/authcode`, accountLinkingConstants.API_KEY, {
        scope,
        accepted,
    }, {
        headers: {
            Authorization: `Bearer ${authorizationToken}`,
        },
    }).then((res) => handleResponse(res, true))
}

const registerUser = (payload) => {
    const otpToken = payload?.emailToken || payload?.mobileToken || payload?.token;
    return API.post(
        `${API_URL.idpAuth}/user/register`,
        "register_user",
        payload,
        {
            headers: otpToken
                ? { Authorization: `Bearer ${otpToken}` }
                : {},
        }
    ).then((res) => handleResponse(res, true))
}

const resetPassword = (payload) => {
    return API.post(
        `${API_URL.idpAuth}/auth/resetPassword`,
        "reset_password",
        payload
    ).then((res) => handleResponse(res, true))
}

export const userService = {
    systemUserLogin,
    systemUserLogout,
    tenantUserLogin,
    tenantUserLogout,
    getAccountLinkingAuthToken,
    getAccountLinkingAuthTokenViaOtp,
    getAccountLinkingAuthCode,
    registerUser,
    resetPassword,
}
